var ListingSections = {};
ListingSections.init = function () {
  var sections = $('.js-listing-section-cont');
  if (sections.length === 0) return;
  $.each(sections, function () {
    var wrapper = $(this);
    var filter = $(wrapper.data('filter'));
    filter.find('.section-hash-clear').on('click', function (e) {
      e.preventDefault();
      $grid.isotopee({
        filter: '*'
      });
      counter = initShow;
      loadMore(counter);
      filter.find('.section-dropdown-filter').find('option').attr('selected', false);
      filter.find('.section-hash-filter').attr('checked', false);
    });
    filter.find('.section-hash-filter').on('click', function () {
      sectionHashFilter();
    });
    filter.find('.section-dropdown-filter').on('change', function () {
      var inputValue = $(this).val();
      $(this).val(inputValue).find('option[value="' + inputValue + '"]').attr('selected', true);
      sectionHashFilter();
    });
    filter.find('.section-orderby-filter').on('change', function () {
      var inputValue = $(this).val();
      $(this).val(inputValue).find('option[value="' + inputValue + '"]').attr('selected', true);
      sectionHashFilter();
    });
    function sectionHashFilter() {
      var objectFilter = new Object();
      var newObjectFilter = new Array();

      // This will look for radio and checkbox input type that has section-hash-filter class
      filter.find('.section-hash-filter').each(function () {
        var inputName = $(this).attr('name');
        var inputValue = $(this).val();
        if ($(this).prop('checked') == true) {
          objectFilter[inputName + 'List'] += '.filter-' + inputValue + ',';
        }
      });

      // This will look for all select input type that has section-dropdown-filter class
      filter.find('.section-dropdown-filter').each(function () {
        var inputName = $(this).attr('name');
        var inputValue = $(this).find('option:selected').val();
        objectFilter[inputName + 'List'] += '.filter-' + inputValue + ',';
      });

      // console.log(objectFilter);
      $.each(objectFilter, function (filterKey, filterValue) {
        filterValue = filterValue.replace('undefined', '');
        filterValue = filterValue.substr(0, filterValue.length - 1);
        newObjectFilter.push(filterValue.split(','));
      });
      var comma = '';
      var filterData = '';
      var parseNewObjectFilter = combo(newObjectFilter, 0, newObjectFilter.length);
      $.each(parseNewObjectFilter, function (filterKey, filterValue) {
        if (filterData != '') {
          comma = ', ';
        }
        filterData += comma + filterValue;
      });

      // this sort still needed by css order in arrangeComplete function below
      var sortBy = 'title';
      var sortOrder = true;
      var orderBy = filter.find('.section-orderby-filter').find('option:selected').val();
      if (orderBy != '') {
        var orderByArray = orderBy.split('_');
        sortBy = orderByArray[0];
        if (orderByArray[1] == 'desc') {
          sortOrder = false;
        }
      }
      $grid.isotopee({
        filter: filterData,
        sortBy: sortBy,
        sortAscending: sortOrder
      });
      counter = initShow;
      loadMore(counter);
    }
    function combo(arr, i, j) {
      if (j > 0) {
        if (i === j - 1) return arr[i];
        var res = [];
        arr[i].forEach(function (a) {
          combo(arr, i + 1, j).forEach(function (b) {
            res.push(a + b);
          });
        });
        return res;
      }
    }

    // init Isotope
    var $grid = wrapper.find('.section-product-listing').isotopee({
      itemSelector: '.product',
      layoutMode: 'none',
      getSortData: {
        title: '[data-title]',
        price: '[data-price] parseInt'
      }
    });
    $grid.on('arrangeComplete', function (event, filteredItems) {
      if (filteredItems.length == 0) {
        wrapper.find('.section-filter-no-results').show();
      } else {
        wrapper.find('.section-filter-no-results').hide();

        // this will sort according to order using the return filteredItems elements
        for (var i = 0; i < filteredItems.length; i++) {
          filteredItems[i].element.style.order = i;
        }
      }
    });

    //****************************
    // Load more button
    //****************************
    var loadmoreBtn = wrapper.find('.iso-loadmore');
    var initShow = typeof loadmoreBtn.data('items') !== 'undefined' ? parseInt(loadmoreBtn.data('items')) : 24; //number of items loaded on init & onclick load more button
    var counter = initShow; //counter for load more button
    var hidden = 'd-none';
    var lastScrollPosition;
    var isLoadmoreClicked = false;
    loadMore(initShow); //execute function onload

    function loadMore(toShow) {
      var iso = $grid.data('isotopee'); // get Isotope instance

      // Hide all products initially
      $grid.find('.product').addClass(hidden);

      // Get items to display
      var displayedElems = iso.filteredItems.slice(0, toShow).map(function (item) {
        return item.element;
      });

      // Show displayedElems
      $(displayedElems).removeClass(hidden);
      $grid.isotopee('layout');

      // Sort filteredItems
      for (var i = 0; i < iso.filteredItems.length; i++) {
        iso.filteredItems[i].element.style.order = i;
      }

      //when no more to load, hide show more button
      if (counter >= iso.filteredItems.length) {
        loadmoreBtn.addClass(hidden);
      } else {
        loadmoreBtn.removeClass(hidden);
      }

      // Update item count
      var itemCount = wrapper.find('.js-list-item-count');
      if (itemCount.length) {
        if (counter < iso.filteredItems.length) itemCount.text(counter);else itemCount.text(iso.filteredItems.length);
      }

      // Update total count
      var totalCount = wrapper.find('.js-list-total-count');
      if (totalCount.length) totalCount.text(iso.filteredItems.length);

      // Execute only if load more button is clicked
      if (isLoadmoreClicked) {
        $(window).scrollTop(lastScrollPosition);
        isLoadmoreClicked = false;
      }
    }

    //when load more button clicked
    loadmoreBtn.on('click', function () {
      counter = counter + initShow;
      lastScrollPosition = $(window).scrollTop();

      // Hide load more button and display spinner
      loadmoreBtn.addClass(hidden);
      wrapper.find('.silk-spinner').removeClass(hidden);
      setTimeout(function () {
        // Show load more button and hide spinner
        loadmoreBtn.removeClass(hidden);
        wrapper.find('.silk-spinner').addClass(hidden);

        // Set isLoadmoreClicked to true
        isLoadmoreClicked = true;

        // Update listing layout
        loadMore(counter);
      }, 500);
    });
  });
};
ListingSections.init();


// WEBPACK FOOTER //
// ./scripts/components/section.js